module.exports = __webpack_public_path__ + "img/cuff button diameter.1992fb4a.png";